<template>
  <div class="details">
    <div class="banner_box">
      <Banner></Banner>
    </div>
    <div class="text_box">
      <div class="title">
        {{news.newsTitle}}
      </div>
      <div class="info">
        <p>{{news.newsAuthor}}</p>
        <p>发布时间: {{news.createTime}}</p>
      </div>
      <div class="Rich_text">
        <p style="margin-bottom:0.1563rem" v-html="news.newsContent"></p>
      </div>
      <div class="paging">
        <p v-if="preNews.newsTitle == null"></p>
        <p v-else @click="details(preNews.newsId,parseInt(index)-1)"><span>上一篇：</span><span>{{preNews.newsTitle}}</span></p>
        <p v-if="nextNews.newsTitle == null"></p>
        <p v-else @click="details(nextNews.newsId,parseInt(index)+1)"><span>下一篇：</span><span>{{nextNews.newsTitle}}</span></p>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Footer from "@/components/footer.vue";
import Banner from "@/components/banner.vue";
import { listNews,getNews} from "@/api/news";
export default {
  components: {
    Footer,
    Banner
  },
  data () {
    return {
      newsId: null,
      news:{},
      preNews:{},
      nextNews:{},
      index:0,
      newsList:[],
      newsType:null
    }
  },
  created () {
    this.newsId = this.$route.query.id
    this.index = this.$route.query.index
    this.newsType = this.$route.query.newsType != 0 ? this.$route.query.newsType : null;
    this.getNewsList();
    this.getCurrentNews();
  },
  methods: {
    details (row,index) {
      this.$router.push(
        {
          path: "/Journalism/details",
          query: {
            id: row,
            index: index,
            newsType: this.newsType
          }
        }
      )
      /**  刷新当前界面 */
      this.$router.go(0)
    },
    getCurrentNews() {
      getNews(this.newsId).then(response => {
        this.news = response.data;
      });
    },
    getNewsList() {
      listNews({newsType:this.newsType}).then(response => {
        this.newsList = response.rows;
        if(this.index > 0){
          this.preNews = this.newsList[parseInt(this.index)-1];
        }
        if(parseInt(this.index)+1 < this.newsList.length) {
          this.nextNews = this.newsList[parseInt(this.index)+1];
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
.details {
  text-align: center;
  .banner_box {
    width: 100vw;
    height: 100vh;
  }
  .text_box {
    padding: 0.2563rem 1.875rem;

    .title {
      font-size: 0.2083rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #000000;
      letter-spacing: 0.0052rem;
      opacity: 1;
    }
    .info {
      padding: 0.1563rem 0;
      font-size: 0.125rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 0.2083rem;
      color: #999999;
      letter-spacing: 0.0052rem;
      opacity: 1;
      border-bottom: 0.0052rem dashed #999999;
    }
    .Rich_text {
      margin: 0.2604rem 0rem;
      text-align: left;
    }
    .paging {
      display: flex;
      justify-content: space-between;
      p {
        font-size: 0.0781rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        line-height: 0.151rem;
        color: #000000;
        letter-spacing: 0.0052rem;
        opacity: 1;
        cursor: pointer;
        transition: 0.3s;
      }
      p:hover {
        color: #ff6100;
      }
    }
  }
}
</style>